export enum AllowableFreightProgressBarClassEnum {
    Red = 'gardner-red',
    Green = 'gardner-green',
    Yellow = 'gardner-yellow'
}
